import { Injectable } from '@angular/core';
import { ManageTour } from '../gallery/manage-tour.model';
import { ApiService } from './api';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToursService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  getTours(airlineId: number) {
    return this.apiService.get<{ data: ManageTour[] }>(`${this.path}/v2/airlines/${airlineId}/tours`).pipe(map(tours => tours.data));
  }

  getTour(tourId: number, partnerId: number) {
    return this.apiService.get<{ data: ManageTour }>(`${this.path}/v2/airlines/${partnerId}/tours/${tourId}`).pipe(map(tour => tour.data));
  }

  createTour(data: ManageTour, partnerId: number) {
    return this.apiService.post<{ data: ManageTour }>(`${this.path}/v2/airlines/${partnerId}/tours`, { tour: data }).pipe(map(tours => tours.data));
  }

  updateTour(tourId: number, data: ManageTour, partnerId: number) {
    return this.apiService.put<{ data: ManageTour }>(`${this.path}/v2/airlines/${partnerId}/tours/${tourId}`, { tour: data }).pipe(map(tours => tours.data));
  }

  deleteTour(tourId: number, partnerId: number) {
    return this.apiService.delete(`${this.path}/v2/airlines/${partnerId}/tours/${tourId}`);
  }
}
